export default __webpack_public_path__ + "static/media/Photo 6 - BR - mode de vie.3df6c323.png";